/**
 * @generated SignedSource<<f0c5478807a27f8ecac027d349e50a5c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type RoutineType = "DEFAULT" | "EVENT_ITEM" | "KPI" | "STANDARD" | "TEMPLATE";
export type TaskImportance = "OPTIONAL" | "REQUIRED";
export type TaskSentiment = "NEGATIVE" | "NEUTRAL" | "POSITIVE";
import { FragmentRefs } from "relay-runtime";
export type RoutineEditScheduleCard_Routine$data = {
  readonly activeVersion: {
    readonly tasks: ReadonlyArray<{
      readonly __typename: string;
      readonly id: string;
      readonly sentiments?: ReadonlyArray<TaskSentiment>;
      readonly title: string;
    }>;
  };
  readonly currentSchedule: {
    readonly __typename: "RoutineScheduleDaily";
    readonly deadlineDuration: number | null;
    readonly hasAdvancedScheduling: boolean;
    readonly isAllDay: boolean | null;
    readonly weekdays: ReadonlyArray<{
      readonly startTime: {
        readonly hour: number;
        readonly minute: number;
      } | null;
      readonly tasks: ReadonlyArray<{
        readonly importance: TaskImportance;
        readonly taskId: string;
      }>;
      readonly weekday: number;
    }>;
  } | {
    readonly __typename: "RoutineScheduleMonthly";
    readonly endDay: number | null;
    readonly months: ReadonlyArray<number>;
    readonly startDay: number;
  } | {
    readonly __typename: "RoutineScheduleWeekly";
    readonly endWeekday: number | null;
    readonly startWeekday: number | null;
    readonly weeks: ReadonlyArray<number>;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly id: string;
  readonly title: string;
  readonly type: RoutineType;
  readonly " $fragmentType": "RoutineEditScheduleCard_Routine";
};
export type RoutineEditScheduleCard_Routine$key = {
  readonly " $data"?: RoutineEditScheduleCard_Routine$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoutineEditScheduleCard_Routine">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoutineEditScheduleCard_Routine",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RoutineVersion",
      "kind": "LinkedField",
      "name": "activeVersion",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "tasks",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "sentiments",
                  "storageKey": null
                }
              ],
              "type": "TaskCheck",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentSchedule",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "deadlineDuration",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isAllDay",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasAdvancedScheduling",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RoutineScheduleDailyWeekday",
              "kind": "LinkedField",
              "name": "weekdays",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "weekday",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Time",
                  "kind": "LinkedField",
                  "name": "startTime",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hour",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "minute",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RoutineScheduleTaskImportance",
                  "kind": "LinkedField",
                  "name": "tasks",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "importance",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "taskId",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "RoutineScheduleDaily",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startWeekday",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endWeekday",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "weeks",
              "storageKey": null
            }
          ],
          "type": "RoutineScheduleWeekly",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startDay",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endDay",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "months",
              "storageKey": null
            }
          ],
          "type": "RoutineScheduleMonthly",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Routine",
  "abstractKey": null
};
})();

(node as any).hash = "80ccfb273e304d61dbf337feab41bb26";

export default node;
